import { tickerItems } from '@/mocks/home';

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="relative z-10 border-y border-background-200 bg-accent-100">
      <div className="mx-auto flex max-w-7xl items-stretch">
        <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-4 py-3 text-sm font-medium text-foreground-950 md:px-6">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-flashlight-fill text-base"></i>
          </span>
          <span className="whitespace-nowrap">滚动速报</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {loop.map((item, index) => (
              <span
                key={`${index}-${item.slice(0, 6)}`}
                className="flex items-center gap-3 whitespace-nowrap px-5 py-3 text-sm text-foreground-800"
              >
                <span className="h-1 w-1 shrink-0 rounded-full bg-primary-500"></span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}